<template>
	<v-main v-if="presentation.status && JSON.parse(presentation.status)" :style="{ backgroundColor: presentationColor.bottomBackgroundColor }">
		<v-card tile :style="{ backgroundColor: presentationColor.backgroundColor }">
			<v-card-text>
				<v-container class="d-flex flex-column">
					<v-row>
						<v-col  v-if="type && type != typePreRecordedVideo" :cols="previous || next ? 3 : 12" class="text-left">
							<div class="back-to-auditorium">
								<v-btn
									@click="navigateToAuditoriumPage()"
									color="white"
									rounded
									style="text-transform: none;margin-top: -10px;"
								>
									<v-icon color="#9b9b9b">mdi-chevron-left</v-icon>
									<p style="color: #aeaeae; font-weight: bold; font-size: 14px; padding-top: 13px; letter-spacing: 0px">
										Auditorium
									</p>
								</v-btn>
							</div>
						</v-col>
						<v-col v-else cols="4">
						</v-col>
						<v-col cols="9" class="text-right">
							<v-btn
								v-if="previous"
								:to="
									'/' +
									tenantSlug +
									'/' +
									experienceSlug +
									'/passthrough/presentation/previous/' +
									previous.trackId +
									'/' +
									previous.presentationScheduleId +
									'/' +
									previous.presentationId
								"
								style="border-radius: 25px; width: 100px; text-transform: none; color: white"
								color="black"
								depressed
								tile
								>Previous</v-btn
							>
							<v-btn
								v-if="next"
								class="ml-3"
								:to="
									'/' +
									tenantSlug +
									'/' +
									experienceSlug +
									'/passthrough/presentation/next/' +
									next.trackId +
									'/' +
									next.presentationScheduleId +
									'/' +
									next.presentationId
								"
								style="border-radius: 25px; width: 100px; text-transform: none; color: white"
								color="black"
								depressed
								tile
								>Next</v-btn
							>
						</v-col>
					</v-row>
					<v-divider style="background-color: grey"></v-divider>
					<v-col class="text-center" v-if="type && type != typeOnDemandVideo && startTime >= 0">
						<span :style="{ color: presentationColor.fontColor }">Scheduled to start in {{ formatTime(startTime) }}</span>
					</v-col>
					<v-row>
						<!-- For website -->
						<template v-if="!isMobile">
							<v-col cols="12" sm="8" :style="{ color: presentationColor.fontColor }" style="padding: 22px 0px 0px 14px">
								<p style="font-size: 30px; font-weight: bold; line-height: 35px">{{ presentation.title }}</p>
								<p class="mt-4" style="font-size: 17px" v-html="presentation.description"></p>
							</v-col>
							<v-col
								cols="12"
								sm="4"
								class="d-flex flex-column"
								:style="{ color: presentationColor.fontColor }"
								style="padding: 15px 15px 0px 0px"
							>
								<div class="d-flex flex-row justify-end mb-2" v-for="(presenter, idxPresenter) in presentation.presenterList" :key="idxPresenter">
									<div class="mt-6">
										<a
											style="text-decoration: none; margin-right: 10px; font-weight: bold"
											:style="{ color: presentationColor.fontColor }"
											@click="
												selectedPresenterName = presenterName(presenter, false);
												selectedPresenterBio = presenter.bio;
												dialogBio = true;
											"
											>{{ presenterName(presenter, true) }}</a
										>
									</div>
									<v-avatar
										size="70"
										color="teal"
										style="cursor: pointer"
										@click="
											selectedPresenterName = presenterName(presenter, false);
											selectedPresenterBio = presenter.bio;
											dialogBio = true;
										"
									>
										<v-img
											v-if="presenter.image != null && !imgError[presenter.id]"
											:src="baseLocation + '/asset/file/user/' + presenter.image + '?c=' + imgCaching"
											@error="imgError[presenter.id] = !imgError[presenter.id]"
										/>
										<v-img v-else :src="baseLocation + '/resource/image/default-avatar.png'" />
									</v-avatar>
								</div>
							</v-col>
						</template>
						<!-- For Mobile -->
						<template v-else>
							<v-col cols="12" class="d-flex flex-column" :style="{ color: presentationColor.fontColor }" style="padding: 15px 15px 0px 0px">
								<div class="d-flex flex-row mb-2" v-for="(presenter, idxPresenter) in presentation.presenterList" :key="idxPresenter">
									<v-avatar
										class="ml-3"
										size="45"
										color="teal"
										style="cursor: pointer"
										@click="
											selectedPresenterName = presenterName(presenter, false);
											selectedPresenterBio = presenter.bio;
											dialogBio = true;
										"
									>
										<v-img
											v-if="presenter.image != null && !imgError[presenter.id]"
											:src="baseLocation + '/asset/file/user/' + presenter.image + '?c=' + imgCaching"
											@error="imgError[presenter.id] = !imgError[presenter.id]"
										/>
										<v-img v-else :src="baseLocation + '/resource/image/default-avatar.png'" />
									</v-avatar>
									<div class="mt-2 ml-3">
										<a
											style="text-decoration: none; margin-right: 10px; font-weight: bold"
											:style="{ color: presentationColor.fontColor }"
											@click="
												selectedPresenterName = presenterName(presenter, false);
												selectedPresenterBio = presenter.bio;
												dialogBio = true;
											"
											>{{ presenterName(presenter, true) }}</a
										>
									</div>
								</div>
							</v-col>
							<v-col cols="12" :style="{ color: presentationColor.fontColor }" style="padding: 2px 0px 0px 14px">
								<p style="font-size: 15px; font-weight: bold; margin-bottom: 3px !important">{{ presentation.title }}</p>
								<p style="margin-bottom: 0px !important" v-html="presentation.description"></p>
							</v-col>
						</template>
					</v-row>
					<v-divider style="background-color: grey"></v-divider>
					<br />

					<v-row>
						<v-col v-if="presentation.embedHtmlBesideMap.status == 'Left'"  cols="12" :sm="smLeft" class="pa-0 pl-4">
							<v-tabs
								v-model="tabEmbedHtmlBeside"
								light
								color="black"
								slider-color="#1fabed"
								slider-size='3'
							>
								<v-tab
									class="pa-0"
									v-for="(tab, index) in presentation.embedHtmlBesideMap.tabs" :key="index"
								>
									<span class="mr-4 ml-2 font-weight-bold" style="text-transform: none;">{{tab.name}}</span>
								</v-tab>
							</v-tabs>
							<v-tabs-items v-if="presentation.embedHtmlBesideMap.status == 'Left'" v-model="tabEmbedHtmlBeside">
								<v-tab-item v-for="(tab, index) in presentation.embedHtmlBesideMap.tabs" :key="index" >
									<template v-if="tab.name !== 'Resources'">
										<div
											v-if="!tab.isUsingIframe"
											v-append="tab.value"
											class="mt-3 pa-4"
											:style="{
												overflow: 'auto',
												height: presentation.dataMap.heightEmbedHtmlBeside + 'px',
												border: '1px solid grey',
												borderRadius: '10px',
												color: 'black'
											}"
										></div>
										<iframe
											v-else
											:src="'data:text/html;charset=utf-8,' + tab.value"
											class="mt-3 pa-1"
											:style="{
												overflow: 'auto',
												height: presentation.dataMap.heightEmbedHtmlBeside + 'px',
												border: '1px solid grey',
												borderRadius: '10px',
												color: 'black',
												width: '100%'
											}"
										/>
									</template>
									<div
										v-else
										class="mt-3 pa-4"
										:style="{
											overflow: 'auto',
											height: presentation.dataMap.heightEmbedHtmlBeside + 'px',
											border: '1px solid grey',
											borderRadius: '10px',
											color: 'black'
										}"
									>
										<div class="content" v-for="(itemHandout, idxItemHandout) in presentation.handoutList" :key="idxItemHandout">
											<v-row class="py-2">
												<v-col cols="12" sm="12">
													<v-icon color="black">mdi-file-document-outline</v-icon>
													<span :style="{ color: presentationColor.fontColor }">{{ itemHandout.title }}</span>
												</v-col>
												<v-col cols="12" xl="7" lg="12">
													<v-btn
														rounded
														small
														:style="{
															backgroundColor: presentationColor.buttonBackgroundColor2,
															color: presentationColor.buttonFontColor2
														}"
														class="mx-4"
														v-if="itemHandout"
														@click="saveToMyDocument(itemHandout.id)"
														>Save To My Document</v-btn
													>
												</v-col>
												<v-col cols="12" xl="5" lg="12">
													<v-btn
														rounded
														small
														:style="{
															backgroundColor: presentationColor.buttonBackgroundColor2,
															color: presentationColor.buttonFontColor2
														}"
														class="mx-4"
														v-if="itemHandout"
														@click="download(itemHandout.value)"
														>Download</v-btn
													>
												</v-col>
											</v-row>
										</div>
									</div>
								</v-tab-item>
							</v-tabs-items>
						</v-col>
						<v-col cols="12" :sm="smCenter" class="pt-15">
							<!-- Zoom Button -->
							<template
								v-if="
									presentation.zoomLink == true &&
									(type == typeZoomMeeting || type == typeZoomWebinar) &&
									presentation.dataMap.toEndTime >= 0
								"
								style="min-width: 100%"
							>
								<center>
									<v-btn color="secondary" :href="presentation.participantUrl" target="_blank">Launch Zoom app off platform</v-btn>
									<br />
									<span :style="{ color: presentationColor.fontColor }"
										>If you are on Apple or having difficulty viewing the presentation below click the button above to launch Zoom
										app</span
									>
									<br />
									<br />
								</center>
							</template>

							<!-- Presentation URL Button -->
							<template v-if="type == typePresentationUrl && presentation.dataMap.toEndTime >= 0" style="min-width: 100%">
								<center>
									<v-btn color="secondary" :href="presentation.presentationUrl" target="_blank">Join presentation</v-btn>
									<br />
									<br />
								</center>
							</template>

							<!-- On Demand -->
							<iframe
								v-if="type == typeOnDemandVideo && videoUrl != null"
								frameborder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
								height="450"
								ref="contentPresentation"
								:src="modifyVideoUrl(videoUrl)"
								allowfullscreen
								style="min-width: 100%"
							></iframe>
							<video
								v-else-if="type == typeOnDemandVideo && videoUpload != null"
								:src="baseLocation + '/asset/file/' + videoUpload"
								height="450"
								ref="contentPresentation"
								controls
								autoplay
								playsinline
								disablepictureinpicture
								style="min-width: 100%"
							></video>

							<!-- Zoom -->
							<iframe
								v-else-if="
									presentation &&
									presentation.id &&
									presentation.zoomWeb &&
									(presentation.selectedRole == 0 || presentation.selectedRole == 1) &&
									(type == typeZoomMeeting || type == typeZoomWebinar)
								"
								frameborder="0"
								allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; camera; microphone;"
								height="600"
								ref="contentPresentation"
								:src="
									baseLocation +
									'/zoom.jsp?nickname=' +
									presentation.dataMap.nickname +
									'&email=' +
									$store.state.principal.email +
									'&meetingId=' +
									presentation.dataMap.meetingId +
									'&role=' +
									presentation.selectedRole +
									'&password=' +
									presentation.dataMap.password +
									'&disablePreview=' + ((presentation.dataMap.disablePreview == null || presentation.dataMap.disablePreview === '') ? true : presentation.dataMap.disablePreview)
								"
								allowfullscreen
								style="min-width: 100%"
							></iframe>

							<!-- Teams -->
							<iframe
								v-if="
									presentation &&
									presentation.id &&
									presentation.zoomWeb &&
									(presentation.selectedRole == 0 || presentation.selectedRole == 1) &&
									type == typeTeamsMeeting
								"
								frameborder="0"
								allow="camera; microphone"
								height="600"
								:src="$root.getUrlTeamsWithLink(presentation.participantUrl)"
								allowfullscreen
								style="min-width: 100%"
							></iframe>

							<!-- Vimeo Live -->
							<div v-else-if="type == typeVimeoLive" v-html="videoIframe" ref="contentPresentation"></div>

							<!-- Embed Code -->
							<center v-else-if="type == typeEmbedCode && !presentation.dataMap.embedCodeUsingIframe" style="min-width: 100%">
								<div v-html="presentation.embedCode" ref="contentPresentation"></div>
								<br />
								<p>* If you still get the error message, please make sure cookies are enabled in your browser.</p>
							</center>
							<center v-else-if="type == typeEmbedCode && presentation.dataMap.embedCodeUsingIframe" style="min-width: 100%">
								<iframe width="100%" height="600px" :src="'data:text/html;charset=utf-8,' + presentation.embedCode" />
								<br />
								<p>* If you still get the error message, please make sure cookies are enabled in your browser.</p>
							</center>

							<!-- Training -->
							<iframe
								v-else-if="type == typeTraining"
								style="border:1px solid #e0e0e0;"
								width="100%"
								height="500"
								:src='$vtrainingurl + "/account/?guid=" + vTrainingUserGUID + "&view=training&categories=" + presentation.dataMap.trainingCategories.join("-")'
								allow="camera;microphone"
							>
							</iframe>


							<!-- Simulive -->
							<template v-else-if="type == typePreRecordedVideo">
								<template v-if="startTime <= 0 && endTime >= -5">
									<iframe
										v-if="type == typePreRecordedVideo && videoUrl.includes('youtube')"
										frameborder="0"
										allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
										height="450"
										ref="contentPresentation"
										:src="videoUrl + '?autoplay=1&showinfo=0&controls=1'"
										allowfullscreen
										style="min-width: 100%"
									></iframe>
									<iframe
										v-else-if="type == typePreRecordedVideo && videoUrl.includes('vimeo')"
										allow="autoplay; accelerometer; encrypted-media; gyroscope; picture-in-picture"
										height="450"
										:src="videoUrl"
										ref="contentPresentation"
										frameborder="0"
										allowfullscreen
										style="min-width: 100%"
									></iframe>
									<iframe
										v-else-if="type == typePreRecordedVideo && videoUrl != '' && videoUrl != null"
										frameborder="0"
										allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
										height="450"
										ref="contentPresentation"
										:src="videoUrl + '?autoplay=1&showinfo=0&controls=1'"
										allowfullscreen
										style="min-width: 100%"
									></iframe>
									<video
										v-else-if="type == typePreRecordedVideo && videoUpload != null"
										:src="baseLocation + '/asset/file/' + videoUpload"
										height="450"
										ref="contentPresentation"
										controls
										autoplay
										playsinline
										disablepictureinpicture
										style="min-width: 100%"
									></video>
								</template>
								<template v-else-if="endTime < -5">
									<span :style="{ color: presentationColor.fontColor }">Session ended</span>
								</template>
							</template>
						</v-col>
						<v-col
							v-if="presentation.embedHtmlBesideMap.status == 'Right' ||
								(presentation.handoutList && presentation.handoutList.length > 0 && presentation.embedHtmlBesideMap.status == 'None')"
								cols="12"
								:sm="smRight"
								class="pa-0 pl-4"
							>
							<v-tabs
								v-model="tabEmbedHtmlBeside"
								light
								color="black"
								slider-color="#1fabed"
								slider-size='3'
							>
								<template v-if="presentation.embedHtmlBesideMap.status == 'Right'">
									<v-tab
										class="pa-0"
										v-for="(tab, index) in presentation.embedHtmlBesideMap.tabs" :key="index"
									>
										<span class="mr-4 ml-2 font-weight-bold" style="text-transform: none;">{{tab.name}}</span>
									</v-tab>
								</template>
							</v-tabs>
							<v-tabs-items
								v-if="presentation.embedHtmlBesideMap.status == 'Right' ||
									(presentation.handoutList && presentation.handoutList.length > 0 && presentation.embedHtmlBesideMap.status == 'None')"
								v-model="tabEmbedHtmlBeside"
							>
								<template v-if="presentation.embedHtmlBesideMap.status == 'Right'">
									<v-tab-item  v-for="(tab, index) in presentation.embedHtmlBesideMap.tabs" :key="index" >
										<template v-if="tab.name !== 'Resources'">
											<div
												v-if="!tab.isUsingIframe"
												v-append="tab.value"
												class="mt-3 pa-4"
												:style="{
													overflow: 'auto',
													height: presentation.dataMap.heightEmbedHtmlBeside + 'px',
													border: '1px solid grey',
													borderRadius: '10px',
													color: 'black'
												}"
											></div>
											<iframe
												v-else
												:src="'data:text/html;charset=utf-8,' + tab.value"
												class="mt-3 pa-1"
												:style="{
													overflow: 'auto',
													height: presentation.dataMap.heightEmbedHtmlBeside + 'px',
													border: '1px solid grey',
													borderRadius: '10px',
													color: 'black',
													width: '100%'
												}"
											/>
										</template>
										<div
											v-else
											class="mt-3 pa-4"
											:style="{
												overflow: 'auto',
												height: presentation.dataMap.heightEmbedHtmlBeside + 'px',
												border: '1px solid grey',
												borderRadius: '10px',
												color: 'black'
											}"
										>
											<div class="content" v-for="(itemHandout, idxItemHandout) in presentation.handoutList" :key="idxItemHandout">
												<v-row class="py-2">
													<v-col cols="12" sm="12">
														<v-icon color="black">mdi-file-document-outline</v-icon>
														<span :style="{ color: presentationColor.fontColor }">{{ itemHandout.title }}</span>
													</v-col>
													<v-col cols="12" xl="7" lg="12">
														<v-btn
															rounded
															small
															:style="{
																backgroundColor: presentationColor.buttonBackgroundColor2,
																color: presentationColor.buttonFontColor2
															}"
															class="mx-4"
															v-if="itemHandout"
															@click="saveToMyDocument(itemHandout.id)"
															>Save To My Document</v-btn
														>
													</v-col>
													<v-col cols="12" xl="5" lg="12">
														<v-btn
															rounded
															small
															:style="{
																backgroundColor: presentationColor.buttonBackgroundColor2,
																color: presentationColor.buttonFontColor2
															}"
															class="mx-4"
															v-if="itemHandout"
															@click="download(itemHandout.value)"
															>Download</v-btn
														>
													</v-col>
												</v-row>
											</div>
										</div>
									</v-tab-item>
								</template>
							</v-tabs-items>
						</v-col>
					</v-row>
					<div
						v-if="presentation.embedHtmlBelow"
						v-append="presentation.embedHtmlBelow"
						:style="{
							overflow: 'auto',
							height: presentation.dataMap.heightEmbedHtmlBelow + 'px',
							color: 'black'
						}"
					></div>
				</v-container>
			</v-card-text>
			<br />
		</v-card>

		<v-dialog v-model="dialogBio" persistent width="800">
			<v-card tile>
				<v-card-title>
					<span class="headline">{{ selectedPresenterName }}</span>
					<v-spacer></v-spacer>
					<v-icon @click="dialogBio = false">mdi-close</v-icon>
				</v-card-title>
				<v-divider class="mx-4"></v-divider>
				<v-card-text>{{ selectedPresenterBio }}</v-card-text>
			</v-card>
		</v-dialog>

		<!-- Chat Box START -->

		<v-container id="chatCard" v-if="presentation.dataMap.noChatPresentation == null || presentation.dataMap.noChatPresentation == false">
			<v-row no-gutters class="d-flex">
				<v-col v-if="!isMobile" cols="11">
					<v-card-text class="font-weight-bold" style="font-size: 30px"> Presentation Chat </v-card-text>
				</v-col>
				<v-col v-else cols="8">
					<v-card-text class="font-weight-bold" style="font-size: 20px"> Presentation Chat </v-card-text>
				</v-col>
				<v-col :cols="!isMobile ? 1 : 4" class="d-flex justify-end pt-3">
					<v-btn
						v-if="chatBox.chatNotificationSound"
						style="border-radius: 25px; border: 1px solid #dbdbdb; width: 98px; height: 40px; background-color: white"
						@click="soundSwitch(chatBox)"
					>
						<a style="padding-right: 40px; color: #dbdbdb; font-size: 12px; text-transform: none; letter-spacing: 0">Mute</a>
						<v-icon class="d-flex justify-end" size="40" color="#dbdbdb" style="padding-left: 57px; position: absolute"
							>mdi-bell-circle</v-icon
						>
					</v-btn>
					<v-btn v-else style="border-radius: 25px; border: 1px solid #ff8900; width: 98px; height: 40px" @click="soundSwitch(chatBox)">
						<div style="position: absolute; width: 35px; height: 35px; background-color: #ff8900; right: 52px; border-radius: 50%"></div>
						<v-icon class="d-flex justify-end" size="23" color="white" style="padding-right: 54px; position: absolute" dark
							>mdi-bell-off</v-icon
						>
						<a style="padding-left: 33px; color: #ff8900; font-size: 12px; text-transform: none; letter-spacing: 0">Un-mute</a>
					</v-btn>
				</v-col>
			</v-row>
		</v-container>

		<v-container
			id="chatCard"
			v-if="presentation.dataMap.noChatPresentation == null || presentation.dataMap.noChatPresentation == false"
			style="margin-bottom: 80px"
		>
			<v-row no-gutters v-if="presentation.transitMap.isUseCometChat">
				<v-col :cols="!isMobile ? 3 : 12" class="pa-0" v-if="!isMobile || (isMobile && showMobileConversation)">
					<v-card class="scrollable mr-3" height="100%" style="border-radius: 15px; border: 1px solid #ddd4d4">
						<v-tabs v-model="chatTab" background-color="black" dark show-arrows fixed-tabs v-if="isMobile && showMobileConversation">
							<v-tab
								v-model="chatTab"
								v-for="(category, idxCategory) in chatCategories"
								:key="idxCategory"
								@click="goToSelectedTab(category.content)"
							>
								<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>

						<v-card v-if="!isMobile" height="40px" style="border: none" elevation="0">
							<a class="mt-2 ml-4" style="position: absolute; color: grey">Conversations</a>
						</v-card>

						<table style="border-collapse: separate; border-spacing: 0; width: 100%">
							<tr
								v-for="(conversation, i) in chatBox.conversationList"
								:key="i"
								:style="{
									backgroundColor: selectedConversationIndex == i ? '#dbdbdb' : '',
									height: '60px'
								}"
							>
								<template v-if="conversation.type == 'group'">
									<td class="pa-2" style="width: 50px">
										<v-avatar>
											<v-icon size="45" color="black">mdi-account-multiple</v-icon>
										</v-avatar>
									</td>
									<div
										class="mt-2"
										style="position: absolute; width: 85%; cursor: pointer"
										@click="converse('group', conversation.id, conversation.name, i)"
									>
										<td class="ellipsis" style="position: absolute; width: 100%">
											<a style="color: black; font-weight: bold; white-space: nowrap; text-overflow: ellipsis;overflow: hidden; position: absolute; width: 100%">
												{{ conversation.name }}
											</a>
											<br />
											<span style="font-size: 12px; color: black">
												{{ conversation.lastMessage && content(conversation.lastMessage) }}
											</span>
										</td>
									</div>
									<td>
										<center>
											<v-avatar size="25" color="red" v-if="conversation.unreadCount">
												<span style="color: white; font-size: 12px">{{ conversation.unreadCount }}</span>
											</v-avatar>
										</center>
									</td>
								</template>
								<template v-else-if="conversation.type == 'user'">
									<td class="pa-2" style="width: 50px">
										<v-avatar>
											<img :src="$root.avatar(conversation.id)" />
										</v-avatar>
									</td>
									<div
										class="mt-2"
										style="position: relative; cursor: pointer"
										@click="converse('user', conversation.id, conversation.name, i)"
									>
										<td class="ellipsis">
											<a style="color: black; font-weight: bold">{{ conversation.name }}</a>
											<br />
											<span style="font-size: 12px; color: #6e6c6c">
												{{ conversation.lastMessage && content(conversation.lastMessage) }}
											</span>
										</td>
									</div>
									<td>
										<center>
											<v-avatar size="25" color="red" v-if="conversation.unreadCount">
												<span style="color: white; font-size: 12px">{{ conversation.unreadCount }}</span>
											</v-avatar>
										</center>
									</td>
								</template>
							</tr>
						</table>
					</v-card>
				</v-col>
				<v-col :cols="!isMobile ? 6 : 12" class="pa-0" v-if="!isMobile || (isMobile && showMobileChat)">
					<v-card class="mr-3 ml-3" style="border-radius: 15px; border: 1px solid #ddd4d4">
						<v-tabs v-model="chatTab" background-color="black" dark show-arrows fixed-tabs v-if="isMobile && showMobileChat">
							<v-tab
								v-model="chatTab"
								v-for="(category, idxCategory) in chatCategories"
								:key="idxCategory"
								@click="goToSelectedTab(category.content)"
							>
								<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>

						<v-card-text class="pa-0" style="border-bottom: 1px solid #eee">
							<h4 class="pt-2 pl-3" style="height: 40px">{{ this.chatBox.conversation.name }}</h4>
							<div class="scrollable pt-2" id="chatBox" style="background-color: #dbdbdb">
								<v-progress-linear rounded v-show="chatBox.loading" :indeterminate="chatBox.loading"></v-progress-linear>

								<center>
									<a v-if="!chatBox.noMore" @click="listMessageHistory">Load previous messages</a>
								</center>

								<div v-for="(message, idxMessage) in chatBox.messageList" :key="idxMessage">
									<!-- incoming -->
									<div v-if="message.sender.uid != chatBox.chatUser.uid && message.category == 'message'">
										<table class="mb-8" style="width: 100%">
											<tr class="d-flex">
												<td class="mt-4 pl-5" style="vertical-align: top; min-width: 70px">
													<v-avatar>
														<v-img :src="$root.avatar(message.sender.uid)" />
													</v-avatar>
												</td>
												<td class="mr-3 ml-4">
													<span class="pa-2">{{ message.sender.name }}</span>
													<v-card class="d-flex pa-2" style="border-radius: 10px">
														<br />
														<span :style="{ color: message.category == 'message' ? 'rgba(0,0,0,0.95)' : '#a5a5a5' }">
															{{ content(message) }}
														</span>
													</v-card>
												</td>
												<td class="ml-auto align-self-center" style="min-width: 70px">
													<div style="color: #646464; font-size: 12px">{{ formatDate(message.sentAt) }}</div>
												</td>
											</tr>
										</table>
									</div>

									<!-- outgoing -->
									<div v-else-if="message.category == 'message'" style="display: flex">
										<table class="mb-8" style="width: 100%">
											<tr class="d-flex">
												<td class="mr-auto align-self-center" style="min-width: 80px">
													<div class="pl-3" style="color: #646464; font-size: 12px">{{ formatDate(message.sentAt) }}</div>
												</td>
												<td class="mr-3 ml-2">
													<span class="pa-2">{{ getUsernameForChatRoom($store.state.principal) }}</span>
													<v-card class="pa-2" color="#1fabed" style="border-radius: 10px">
														<span :style="{ color: message.category == 'message' ? '#rgba(0,0,0,0.95)' : '#a5a5a5' }">
															{{ content(message) }}
														</span>
													</v-card>
												</td>
												<td style="vertical-align: top; min-width: 70px">
													<v-avatar>
														<v-img :src="$root.avatar(message.sender.uid)" />
													</v-avatar>
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
						</v-card-text>

						<div style="display: flex; align-items: center">
							<v-textarea
								v-model="chatBox.chatMessage"
								:rules="chatBox.chatMessageRules"
								placeholder="Your message..."
								flat
								solo
								dense
								hide-details
								no-resize
								rows="3"
								style="font-size: 13px"
							></v-textarea>
							<v-btn fab x-small color="primary" class="mx-5" @click="sendMessage">
								<v-icon>mdi-send</v-icon>
							</v-btn>
						</div>
					</v-card>
				</v-col>

				<v-col :cols="!isMobile ? 3 : 12" class="pa-0" v-if="!isMobile || (isMobile && showMobileUserOnline)">
					<v-card class="scrollable ml-3" height="100%" style="border-radius: 15px; border: 1px solid #ddd4d4">
						<v-tabs v-model="chatTab" background-color="black" dark show-arrows fixed-tabs v-if="isMobile && showMobileUserOnline">
							<v-tab
								v-model="chatTab"
								v-for="(category, idxCategory) in chatCategories"
								:key="idxCategory"
								@click="goToSelectedTab(category.content)"
							>
								<v-badge :value="category.isBadgeOn" dot color="red">{{ category.tab }}</v-badge>
							</v-tab>
						</v-tabs>

						<v-card v-if="!isMobile" height="40px" style="border: none" elevation="0">
							<a class="pl-4 pt-2" style="position: absolute; color: grey">
								Users Online
								<v-menu top offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn icon v-bind="attrs" v-on="on">
											<v-icon>mdi-information-outline</v-icon>
										</v-btn>
									</template>

									<v-list dense>
										<v-list-item>
											<v-list-item-title>You don't see yourself as online in the list below.</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</a>
						</v-card>

						<table style="height: 60px">
							<tr v-for="(visitor, i) in chatBox.visitorList" :key="i">
								<td class="pa-2" style="width: 50px">
									<v-avatar>
										<img :src="$root.avatar(visitor.uid)" />
									</v-avatar>
								</td>
								<td @click="converse('user', visitor.uid, visitor.name)" style="cursor: pointer">{{ visitor.name }}</td>
								<td>
									<v-btn icon small @click="converse('user', visitor.uid, visitor.name)">
										<v-icon>mdi-message</v-icon>
									</v-btn>
								</td>
								<td>
									<v-menu offset-y class="mx-2">
										<template v-slot:activator="{ on, attrs }">
											<v-btn icon small v-bind="attrs" v-on="on">
												<v-icon>mdi-phone</v-icon>
											</v-btn>
										</template>
										<v-list flat elevation="0">
											<v-list-item @click="callUser(visitor.uid, 'video', 'user')">
												<v-list-item-icon class="mr-4">
													<v-icon>mdi-video</v-icon>
												</v-list-item-icon>

												<v-list-item-content>
													<v-list-item-title>Video Call</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
											<v-list-item @click="callUser(visitor.uid, 'audio', 'user')">
												<v-list-item-icon class="mr-4">
													<v-icon>mdi-microphone</v-icon>
												</v-list-item-icon>

												<v-list-item-content>
													<v-list-item-title>Audio Call</v-list-item-title>
												</v-list-item-content>
											</v-list-item>
										</v-list>
									</v-menu>
								</td>
							</tr>
						</table>
					</v-card>
				</v-col>

				<!-- incoming call dialog -->
				<v-dialog v-model="call.incomingCall" persistent no-click-animation max-width="300">
					<v-card rounded="xl" dark elevation="0">
						<v-card-text class="d-flex flex-column align-center pa-4">
							Incoming call
							<br />
							<span class="font-weight-bold body-1" style="text-align: center">
								{{ call.caller && call.caller.name ? call.caller.name : "" }}
							</span>
						</v-card-text>
						<v-card-actions class="pt-2 pb-4 px-8">
							<v-btn class="mx-2" fab dark color="green" @click="acceptCall()">
								<v-icon dark>mdi-phone</v-icon>
							</v-btn>
							<v-spacer></v-spacer>
							<v-btn class="mx-2" fab dark color="red" @click="rejectCall('reject')">
								<v-icon dark>mdi-phone-hangup</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>

				<!-- ongoing call dialog -->
				<v-dialog v-model="call.ongoingCall" persistent no-click-animation max-width="500">
					<v-card dark elevation="0">
						<div id="callScreen"></div>
					</v-card>
				</v-dialog>

				<!-- call on progress dialog -->
				<v-dialog v-model="call.callingProgress" persistent no-click-animation max-width="300">
					<v-card rounded="xl" dark elevation="0">
						<v-card-text class="d-flex flex-column align-center pa-4">
							Calling...
							<br />
							<span class="font-weight-bold body-1" style="text-align: center">
								{{ call.receiver && call.receiver.name ? call.receiver.name : "" }}
							</span>
						</v-card-text>
						<v-card-actions class="pt-2 pb-4 px-8 d-flex flex-column align-center">
							<v-btn class="mx-2" fab dark color="red" @click="rejectCall('cancel')">
								<v-icon dark>mdi-phone-hangup</v-icon>
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-row>
			<v-row v-else >
				<v-col cols="12" class="ml-4" style="margin-bottom: 10px">
					<iframe
						id="chatCard"
						:src="$vchaturl + '/frontend/?e=' + $store.state.principal.chatEventToken +
							'&r=' + presentation.transitMap.ChatRoomToken +
							'&u=' + $store.state.principal.chatUserToken +
							'&o=&i=&sr=0&sm=1&seu=0&sru=1'"
						style="height:641px; width: 98%"
						allow="camera; microphone;"
					></iframe>
				</v-col>
			</v-row>
		</v-container>
		<v-row v-if="$store.state.isPoweredBy" style="background-color: black">
			<v-col cols="12" sm="12">
				<div id="v-footer" style="height: 50px; background-color: black">
					<div id="v-footer" style="height: 50px; background-color: black" v-if="$store.state.footerText === ''">
						<p class="text-center" style="color: #cccccc;padding-top: 15px">Powered by <a href="https://v-unite.com/" target="_blank" style="color:#cccccc">V-Unite</a></p>
					</div>
                    <div id="v-footer" style="height: 50px; background-color: black" v-else>
						<p class="text-center" style="color: #cccccc;padding-top: 15px">{{ $store.state.footerText }}</p>
					</div>
				</div>
			</v-col>
		</v-row>

		<!-- Chat Box FINISH -->

		<v-fab-transition>
			<v-btn
				style="z-index: 3"
				v-if="(presentation.dataMap.noChatPresentation == null || presentation.dataMap.noChatPresentation == false) && goToChat"
				class="ma-4 mb-15 pa-2"
				:color="presentationColor.buttonBackgroundColor"
				:style="{ color: presentationColor.buttonFontColor, borderRadius: isMobile ? '25px' : '50px' }"
				dark
				fixed
				bottom
				right
				@click="scrollToChat()"
				width="auto"
				:height="isMobile ? '80px' : '70px'"
			>
				<div class="arrow bounce-down">
					<img :class="isMobile ? 'imgMobile' : ''" src="./../../assets/Chatbox/bounce-arrow-down.png"
						:style="{ right: isMobile ? '-24px' : 'none'}"
					/>
				</div>
				<span v-if="!isMobile" class="pl-4">Go to chat</span>
				<span v-else class="spanMobile"> <br />Chat </span>
			</v-btn>
			<v-btn
				v-else-if="presentation.dataMap.noChatPresentation == null || presentation.dataMap.noChatPresentation == false"
				class="ma-4 mb-15 pa-2"
				:color="presentationColor.buttonBackgroundColor"
				:style="{ color: presentationColor.buttonFontColor, borderRadius: isMobile ? '25px' : '50px' }"
				dark
				fixed
				bottom
				right
				@click="scrollToTopPage()"
				width="auto"
				:height="isMobile ? '80px' : '70px'"
			>
				<div class="arrow bounce-up">
				<img :class="isMobile ? 'imgMobile' : ''" src="./../../assets/Chatbox/bounce-arrow-up.png"
						:style="{ right: isMobile ? '-24px' : 'none' }"
					/>
				</div>
				<span v-if="!isMobile" class="pl-4">Back to top</span>
				<span v-else class="spanMobile"> <br />Top </span>
			</v-btn>
		</v-fab-transition>
	</v-main>
</template>

<style scoped>
.ellipsis {
	position: relative;
	padding: 0;
}

.ellipsis span {
	position: absolute;
	left: 0;
	right: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.scrollable {
	overflow-y: auto;
	overflow-x: hidden;
	height: 50vh;
}

#callScreen {
	width: 500px;
	height: 500px;
}

.presentation > .v-expansion-panel-content__wrap {
	padding: 0;
}

/*
 CSS for the main interaction
*/
.accordion > input[type="checkbox"] {
	position: absolute;
	left: -100vw;
}

.accordion .content {
	overflow-y: hidden;
	height: 0;
	transition: height 0.3s ease;
}

.accordion > input[type="checkbox"]:checked ~ .content {
	height: auto;
	overflow: visible;
}

.accordion label {
	display: block;
}

/*
 Styling
*/

.accordion {
	margin-bottom: 1em;
}

.accordion > input[type="checkbox"]:checked ~ .content {
	padding: 15px;
	border-top: 0;
}

.accordion .handle {
	margin: 0;
	line-height: 1.2em;
	height: 50px;
	border-bottom: 1px solid grey;
}

.accordion label {
	color: #fff;
	cursor: pointer;
	font-weight: normal;
	padding: 15px;
}

.accordion .handle i:before {
	font: normal normal normal 24px/1 "Material Design Icons";
	content: "\F0140";
	display: inline-block;
	margin-right: 10px;
	font-size: inherit;
	line-height: 1.556em;
	vertical-align: middle;
}

.accordion > input[type="checkbox"]:checked ~ .handle i:before {
	content: "\F0143";
}

.back-to-auditorium {
	height: 30px;
	position: absolute;
	z-index: 6;
}

.imgMobile {
	width: 50px;
	top: -30px;
	position: absolute;
}

.spanMobile {
	bottom: -35px;
	position: absolute;
}
.arrow {
  text-align: center;
  margin: 8% 0;
}
.bounce-down {
  -moz-animation: bounce-down 2s infinite;
  -webkit-animation: bounce-down 2s infinite;
  animation: bounce-down 2s infinite;
}

@keyframes bounce-down {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(20px);
  }
  100% {
    transform: translateY(0px);
  }
}
.bounce-up {
  -moz-animation: bounce-up 2s infinite;
  -webkit-animation: bounce-up 2s infinite;
  animation: bounce-up 2s infinite;
}

@keyframes bounce-up {
  0%, 20%, 50%, 80%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-20px);
  }
  100% {
    transform: translateY(0px);
  }
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: black;
}
</style>

<script src="https://player.vimeo.com/api/player.js"></script>
<script>
/* eslint-disable */
import axios from "axios";
import configuration from "../../configuration";
import { CometChat } from "@cometchat-pro/chat";
import Vimeo from "@vimeo/player";

export default {
	props: ["tenantSlug", "experienceSlug", "trackId", "presentationScheduleId", "presentationId", "linkToType"],
	data() {
		return {
			// Chat Box START
			chatBox: {
				entered: false,
				messageBuilder: null,
				chatMessage: null,
				chatMessageRules: [(v) => (!!v && /.*[^ ].*/.test(v)) || "Please enter your message"],
				chatUser: null,
				noMore: true,
				loading: false,
				messageList: [], // active conversation message list
				visitorList: [], // online user list
				limit: 50, // max is 50
				existingGroupId: null,
				groupId: this.$store.state.principal.experienceId + "-p-" + this.presentationId,
				busId: this.$store.state.principal.experienceId + "-bus",
				conversation: {}, // active conversation
				conversationList: [], // conversation list on left pane
				chatNotificationSound: false
			},
			// Chat Box END

			//mobile version START

			chatTab: null,
			chatCategories: [
				{ tab: "Conversation", content: "1", isBadgeOn: false },
				{ tab: "Chat", content: "2", isBadgeOn: false },
				{ tab: "Users Online", content: "3", isBadgeOn: false }
			],
			isMobile: false,
			showMobileConversation: true,
			showMobileChat: false,
			showMobileUserOnline: false,
			goToChat: true,

			// mobile version END

			// audio-video call START

			call: {
				sessionId: "",
				receiverId: null,
				caller: null,
				receiver: null,
				callingProgress: false,
				incomingCall: false,
				ongoingCall: false
			},

			// audio-video call END

			presentation: {
				dataMap: {},
				selectedRole: null
			},
			dialogBio: false,
			selectedPresenterName: null,
			selectedPresenterBio: null,
			type: null,
			videoUrl: "",
			videoUpload: "",
			videoIframe: "",
			liveTime: 0,
			startTime: null,
			endTime: null,
			sessionEnded: null,
			typeOnDemandVideo: "On-Demand Video",
			typePreRecordedVideo: "Pre-recorded Video",
			typeZoomWebinar: "Zoom Webinar",
			typeZoomMeeting: "Zoom Meeting",
			typeTeamsMeeting: "Teams Meeting",
			typeVimeoLive: "Vimeo Live",
			typePresentationUrl: "Presentation URL",
			typeEmbedCode: "Embed Code",
			typeTraining: "Training",
			previous: null,
			next: null,
			baseLocation: axios.defaults.baseURL,
			experienceUserList: [],
			prevRoute: {},
			imgError: {},
			imgCaching: this.$root.randomNumber(),
			presentationColor: {
				backgroundColor: "#FFFFFFFF",
				bottomBackgroundColor: "#FFFFFFFF",
				fontColor: "#000000",
				buttonBackgroundColor: "#1fabed",
				buttonFontColor: "#FFFFFFFF",
				buttonBackgroundColor2: "#EB7226FF",
				buttonFontColor2: "#FFFFFFFF"
			},
			smLeft: 0,
			smCenter: 12,
			smRight: 0,
			selectedConversationIndex: 0,
			tabEmbedHtmlBeside: 0,
			vTrainingUserGUID: ""
		};
	},
	mounted() {
		this.onResize();
		window.addEventListener("resize", this.onResize, { passive: true });
		this.findPresentationByPresentationIdPresentationScheduleId(this.presentationId, this.presentationScheduleId);
		this.findPreviousPresentation();
		this.findNextPresentation();
		this.getExperienceUser();
		this.scrollToTop();
		this.findExperienceColors();
		if (this.$root.showLiveSupport) {
			this.$root.setCurrentUrlLiveSupport(this.$router.currentRoute.path);
		}
		window.onscroll = () => {
			this.scrollCheck();
		};
	},
	beforeDestroy: function () {
		this.cometExit();
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.prevRoute = from;
		});
	},
	methods: {
		findPresentationByPresentationIdPresentationScheduleId(presentationId, presentationScheduleId) {
			axios
				.post("/system/presentation/presentationschedule/find", {
					presentationId: presentationId,
					presentationScheduleId: presentationScheduleId
				})
				.then((response) => {
					this.presentation = response.data;

					if (!JSON.parse(this.presentation.status)) {
						alert("Presentation is inactive!");
					} else {
						var role = 0;
						if (this.presentation.dataMap.isHost == true) {
							role = 1;
							if (this.presentation.type === this.typeZoomWebinar) {
								role = 0;
							}
						}
						this.presentation.selectedRole = role;

						this.type = this.presentation.type;
						if (this.presentation.videoUrl !== undefined && this.presentation.videoUrl.includes("http")) {
							this.videoUrl = this.presentation.videoUrl;
						} else if (this.presentation.videoUrl !== undefined) {
							this.videoUpload = this.presentation.videoUrl;
						}
						this.videoIframe = this.presentation.videoIframe;

						this.startTime = this.presentation.dataMap.toStartTime;
						this.endTime = this.presentation.dataMap.toEndTime;
						this.liveTime = this.presentation.dataMap.toLiveTime;
						if (this.liveTime < 0) {
							this.liveTime = 0;
						}

						if (this.presentation.transitMap.isUseCometChat) {
							this.cometEnter();
						}

						if (this.type == this.typeTraining) {
							axios
								.get("/system/vTraining/user/guid")
								.then(async (response) => {
									if (response.data) {
										this.vTrainingUserGUID = response.data;
									}
							})
						}

						this.$nextTick(() => {
							if (!this.presentation.dataMap.heightEmbedHtmlBeside) {
								this.presentation.dataMap.heightEmbedHtmlBeside = this.$refs.contentPresentation.clientHeight;
							}
							if (!this.presentation.dataMap.heightEmbedHtmlBelow) {
								this.presentation.dataMap.heightEmbedHtmlBelow = this.$refs.contentPresentation.clientHeight;
							}
						});
					}

					if (!this.presentation.embedHtmlBesideMap.tabs && this.presentation.embedHtmlBesideMap.value) {
						this.presentation.embedHtmlBesideMap.tabs = [{name: 'Tab 1', value: this.presentation.embedHtmlBesideMap.value}];
					} else {
						if (!this.presentation.embedHtmlBesideMap.resourcesTabPosition) {
							this.presentation.embedHtmlBesideMap.resourcesTabPosition = 1;
						}

						if (this.presentation.embedHtmlBesideMap.status !== 'None') {
							if (this.presentation.handoutList && this.presentation.handoutList.length > 0) {
								this.presentation.embedHtmlBesideMap.tabs.splice(this.presentation.embedHtmlBesideMap.resourcesTabPosition-1, 0, {name: 'Resources', value: ''})
							}
						} else {
							if (this.presentation.handoutList && this.presentation.handoutList.length > 0) {
								this.presentation.embedHtmlBesideMap.tabs = [{name: 'Resources', value: ''}];
								this.presentation.embedHtmlBesideMap.status = 'Right';
							}
						}
					}

					if (this.presentation.embedHtmlBesideMap.status == "Left") {
						this.smLeft = 3;
						this.smCenter = 9;
						this.smRight = 0;
					} else if (this.presentation.embedHtmlBesideMap.status == "Right" || //
						(this.presentation.handoutList && this.presentation.handoutList.length > 0 && this.presentation.embedHtmlBesideMap.status == 'None')) {
						this.smLeft = 0;
						this.smCenter = 9;
						this.smRight = 3;
					}
				})
				.catch(() => {})
				.finally(() => {
					if (JSON.parse(this.presentation.status)) {
						let activityLog = {
							dataMap: { presentationId: this.presentation.id, trackId: this.trackId }
						};
						if (this.presentation.type != this.typeOnDemandVideo) {
							//live video
							activityLog.type = "Watch_live_presentation";
						} else {
							//non live video
							activityLog.type = "Watch_presentation_video";
						}
						this.$root.saveActivityLog(activityLog);
						this.countDownTimer();
						if (this.presentation.type === this.typePreRecordedVideo) {
							this.playSimuliveVimeo(this.liveTime);
						}
					}
				});
		},
		findNextPresentation() {
			axios
				.post("/system/presentation/find/next", {
					trackId: this.trackId,
					presentationId: this.presentationId,
					presentationScheduleId: this.presentationScheduleId
				})
				.then((response) => {
					let next = response.data;
					if (next && next.presentationId != this.presentationId) {
						this.next = next;
					}
				})
				.catch(() => {});
		},
		findPreviousPresentation() {
			axios
				.post("/system/presentation/find/previous", {
					trackId: this.trackId,
					presentationId: this.presentationId,
					presentationScheduleId: this.presentationScheduleId
				})
				.then((response) => {
					let previous = response.data;
					if (previous && previous.presentationId != this.presentationId) {
						this.previous = previous;
					}
				})
				.catch(() => {});
		},
		getExperienceUser() {
			axios
				.get("/system/user")
				.then((response) => {
					this.chatBox.chatNotificationSound = response.data.chatNotificationSound ? response.data.chatNotificationSound : false;
				})
				.catch(() => {});
		},
		countDownTimer() {
			if (this.endTime >= -5) {
				setTimeout(() => {
					this.startTime -= 1;
					this.endTime -= 1;
					this.$forceUpdate();
					this.countDownTimer();
				}, 1000);
			}
		},
		formatTime(seconds) {
			if (seconds > 86400) {
				return "more than a day";
			} else {
				return new Date(seconds * 1000).toISOString().substr(11, 8);
			}
		},
		download(name) {
			location.href = this.baseLocation + "/asset/file/" + name + "?download&time=" + new Date();
		},
		presenterName(presenter, isMain) {
			if (isMain) {
				return "" + this.$root.textify(presenter.firstName) + this.$root.textify(presenter.lastName, " ");
			} else {
				return (
					"" +
					this.$root.textify(presenter.firstName) +
					this.$root.textify(presenter.lastName, " ") +
					this.$root.textify(presenter.title, ", ")
				);
			}
		},
		saveToMyDocument(id) {
			axios
				.post("/system/document/briefcase/add", {
					experienceUserId: this.$store.state.principal.id,
					documentId: id
				})
				.then((response) => {
					if (response.data == "Saved") {
						let activityLog = {
							dataMap: { presentationId: Number(this.presentationId), documentId: id },
							type: "Add_to_my_documents"
						};
						this.$root.saveActivityLog(activityLog);
					}
				});
		},
		playSimuliveVimeo(currentTime) {
			console.log("current time: " + currentTime);

			var iframe = document.querySelector("iframe");
			var player = new Vimeo(iframe);

			player
				.setCurrentTime(currentTime)
				.then(function () {
					player.setMuted(false).then(function () {
						player
							.play()
							.then(function () {
								console.log("auto-play success");
							})
							.catch(function (error) {
								console.log("auto-play failed!");
							});
					});
				})
				.catch(function (error) {
					player.pause();
					iframe.remove();
					console.log("Live video session has ended!");
					alert("Live video has ended!");
				});
		},
		navigateToAuditoriumPage() {
			if (this.$store.state.auditorium.url != null) {
				window.location.href = this.$store.state.auditorium.url;
			} else {
				axios
					.get("/system/track?id=" + this.trackId)
					.then((response) => {
						this.$router.push(
							"/" +
								this.$route.params.tenantSlug +
								"/" +
								this.$route.params.experienceSlug +
								"/auditorium/" +
								response.data.auditoriumId +
								(this.linkToType != null ? "/track/" + this.trackId : "")
						);
					})
					.catch(() => {});
			}
		},

		// Chat Box START
		async cometEnter() {
			if (!this.presentation.isOwnGroup) {
				this.chatBox.existingGroupId = this.presentation.groupChatId;
			}

			let existingGroupId = this.chatBox.existingGroupId;
			let groupId = this.chatBox.groupId;
			let busId = this.chatBox.busId;

			this.chatBox.entered = true;

			this.chatBox.chatUser = await CometChat.getLoggedinUser();

			let found = false;
			let busFound = false;

			let groupBuilder = new CometChat.GroupsRequestBuilder()
				.joinedOnly(true)
				.setSearchKeyword(this.$store.state.principal.experienceId + "-")
				.setLimit(100)
				.build();

			let groupList = [];
			let customGroupChatId = existingGroupId ? existingGroupId : groupId;
			do {
				groupList = await groupBuilder.fetchNext();
				for (let i of groupList) {
					if (i.guid == customGroupChatId) {
						found = true;
					} else if (i.guid == busId) {
						busFound = true;
					}
				}
			} while (groupList && groupList.length == 100);

			// join group
			let group;
			if (!found) {
				group = await CometChat.joinGroup(customGroupChatId, "public", "");
			}
			if (!busFound) {
				group = await CometChat.joinGroup(busId, "public", "");
			}

			// change role
			this.chatBox.chatUser.role = groupId;
			this.chatBox.chatUser = await CometChat.updateUser(this.chatBox.chatUser, configuration.apiKeyCometChat);

			// notify in bus that just entered group
			await CometChat.sendMessage(
				new CometChat.TextMessage(busId, JSON.stringify({ type: "Enter group", groupId: groupId }), CometChat.RECEIVER_TYPE.GROUP)
			);

			// right pane
			this.listVisitorInitial();

			// center pane
			let customGroup = await this.getGroup(customGroupChatId);

			this.chatBox.conversation.type = "group";
			this.chatBox.conversation.id = customGroupChatId;
			this.chatBox.conversation.name = customGroup.name;
			this.listMessageInitial();

			// left pane
			let lastMessage = await this.getGroupConversationInitial(customGroupChatId);
			this.chatBox.conversationList.push({
				type: "group",
				id: customGroupChatId,
				name: customGroup.name,
				unreadCount: 0,
				lastMessage: lastMessage
			});
			this.listDirectInitial();

			CometChat.addMessageListener(
				"messageListener-" + groupId,
				new CometChat.MessageListener({
					onTextMessageReceived: (textMessage) => {
						if (
							//
							(textMessage.receiverType == "group" &&
								this.chatBox.conversation.type == "group" &&
								textMessage.receiverId == this.chatBox.conversation.id) || //
							(textMessage.receiverType == "user" &&
								this.chatBox.conversation.type == "user" &&
								textMessage.sender.uid == this.chatBox.conversation.id) //
						) {
							this.chatBox.messageList.push(this.minimizeMessage(textMessage));
							this.conversationLastMessage(this.chatBox.conversation.type, this.chatBox.conversation.id, textMessage);

							if (this.chatBox.chatNotificationSound) {
								this.notificationSound();
							}
							this.$nextTick(() => {
								this.scrollToBottom();
							});
						} else if (textMessage.receiverId == busId) {
							let data = JSON.parse(textMessage.data.text);
							if (data.type == "Enter group" && data.groupId == groupId) {
								let uid = textMessage.sender.uid;
								let found = false;
								for (let visitor of this.chatBox.visitorList) {
									if (visitor.uid == uid) {
										found = true;
										break;
									}
								}
								if (!found) {
									this.chatBox.visitorList.push({
										uid: textMessage.sender.uid,
										name: textMessage.sender.name
									});
								}
							} else if ((data.type == "Exit group" && data.groupId == groupId) || data.type == "Logout") {
								let uid = textMessage.sender.uid;
								for (let i in this.chatBox.visitorList) {
									let visitor = this.chatBox.visitorList[i];
									if (visitor.uid == uid) {
										this.chatBox.visitorList.splice(i, 1);
										break;
									}
								}
							}
						} else if (textMessage.receiverType == "group" && textMessage.receiver.guid == customGroupChatId) {
							this.conversationLastMessage("group", customGroupChatId, textMessage);
							this.conversationUnreadIncrement("group", customGroupChatId);
							if (this.chatBox.chatNotificationSound) {
								this.notificationSound();
							}
						} else if (textMessage.receiverType == "user") {
							this.conversationCreateIfNotExist("user", textMessage.sender.uid, textMessage.sender.name, textMessage);
							this.conversationLastMessage("user", textMessage.sender.uid, textMessage);
							this.conversationUnreadIncrement("user", textMessage.sender.uid);
							if (this.chatBox.chatNotificationSound) {
								this.notificationSound();
							}
						}
					},
					onMessagesRead: (messageReceipt) => {}
				})
			);

			// audio-video call START

			let globalContext = this;

			CometChat.addCallListener(
				"callListener-" + groupId,
				new CometChat.CallListener({
					onIncomingCallReceived(call) {
						if (call.callInitiator.uid != globalContext.chatBox.chatUser.uid && !globalContext.call.ongoingCall) {
							console.log("Incoming call:", call);
							globalContext.call.caller = call.callInitiator;
							globalContext.call.receiver = call.callReceiver;
							globalContext.call.incomingCall = true;
							globalContext.call.sessionId = call.sessionId;
						}
					},
					onOutgoingCallAccepted(call) {
						console.log("Outgoing call accepted:", call);

						globalContext.setOnCallAccepted().then(() => {
							let sessionId = call.sessionId;
							let callType = call.type;
							let callSettings = new CometChat.CallSettingsBuilder()
								.setSessionID(sessionId)
								.enableDefaultLayout(true)
								.setIsAudioOnlyCall(callType == "audio" ? true : false)
								.showScreenShareButton(false)
								.build();

							CometChat.startCall(
								callSettings,
								document.getElementById("callScreen"),
								new CometChat.OngoingCallListener({
									onUserJoined: (user) => {
										/* Notification received here if another user joins the call. */
										console.log("User joined call:", user);
									},
									onUserLeft: (user) => {
										/* Notification received here if another user left the call. */
										console.log("User left call:", user);
									},
									onCallEnded: (call) => {
										/* Notification received here if current ongoing call is ended. */
										console.log("Call ended:", call);
										globalContext.call.ongoingCall = false;
										globalContext.call.incomingCall = false;
										globalContext.call.callingProgress = false;
										globalContext.call.receiverId = null;
										globalContext.call.sessionId = "";
									},
									onError: (error) => {
										console.log("Call Error :", error);
										globalContext.call.ongoingCall = false;
										globalContext.call.incomingCall = false;
										globalContext.call.callingProgress = false;
										globalContext.call.receiverId = null;
										globalContext.call.sessionId = "";
									}
								})
							);
						});
					},
					onOutgoingCallRejected(call) {
						console.log("Outgoing call rejected:", call);
						globalContext.call.incomingCall = false;
						globalContext.call.ongoingCall = false;
						globalContext.call.callingProgress = false;
						globalContext.call.receiverId = null;
						globalContext.call.sessionId = "";
					},
					onIncomingCallCancelled(call) {
						console.log("Incoming call cancelled:", call);
						globalContext.call.incomingCall = false;
						globalContext.call.ongoingCall = false;
						globalContext.call.callingProgress = false;
						globalContext.call.receiverId = null;
						globalContext.call.sessionId = "";
					}
				})
			);

			// audio-video call END
		},
		async cometExit() {
			let groupId = this.chatBox.groupId;
			let busId = this.chatBox.busId;

			document.title = "V-Unite";

			if (this.chatBox.entered) {
				CometChat.removeMessageListener("messageListener-" + groupId);
				CometChat.removeCallListener("callListener-" + groupId);

				if (this.$store.state.principal.token) {
					this.chatBox.chatUser.role = "default";
					await CometChat.updateUser(this.chatBox.chatUser, configuration.apiKeyCometChat);

					await CometChat.sendMessage(
						new CometChat.TextMessage(busId, JSON.stringify({ type: "Exit group", groupId: groupId }), CometChat.RECEIVER_TYPE.GROUP)
					);
				}
			}
		},
		async listVisitorInitial() {
			let groupId = this.chatBox.groupId;
			let memberList;
			let list = [];
			let limit = this.chatBox.limit;
			let builder = new CometChat.UsersRequestBuilder().setLimit(limit).setStatus(CometChat.USER_STATUS.ONLINE).setRole(groupId).build();

			do {
				memberList = await builder.fetchNext();
				for (let i of memberList) {
					list.push(this.minimizeVisitor(i));
				}
			} while (memberList && memberList.length == limit);

			this.chatBox.visitorList = list;
		},
		async getGroupConversationInitial(guid) {
			let groupConversation = CometChat.getConversation(guid, "group").then(
				(conversation) => {
					return conversation.lastMessage;
				},
				(error) => {
					this.cometChatErrorNotif(error);
					return null;
				}
			);
			return groupConversation;
		},
		async listDirectInitial() {
			let conversationList;
			let list = [];
			let limit = this.chatBox.limit;
			let builder = new CometChat.ConversationsRequestBuilder().setLimit(limit).setConversationType("user").build();

			do {
				conversationList = await builder.fetchNext();
				for (let i of conversationList) {
					list.push(this.minimizeConversation(i));
					if (this.minimizeConversation(i).unreadCount > 0) {
						document.title = "You have new message(s)";
					}
				}
			} while (conversationList && conversationList.length == limit);

			this.chatBox.conversationList.push(...list);
		},
		listMessageInitial() {
			let limit = this.chatBox.limit;
			let messageList;

			if (this.chatBox.conversation.type == "group") {
				this.chatBox.messageBuilder = new CometChat.MessagesRequestBuilder().setLimit(limit).setGUID(this.chatBox.conversation.id).build();
			} else {
				this.chatBox.messageBuilder = new CometChat.MessagesRequestBuilder().setLimit(limit).setUID(this.chatBox.conversation.id).build();
			}

			this.chatBox.noMore = false;
			this.chatBox.loading = true;

			this.chatBox.messageList.splice(0, this.chatBox.messageList.length);
			this.chatBox.messageBuilder
				.fetchPrevious()
				.then((messageList) => {
					if (messageList.length < limit) {
						this.chatBox.noMore = true;
					}
					let lastMessage;
					for (let m of messageList) {
						this.chatBox.messageList.push(this.minimizeMessage(m));
						lastMessage = m;
					}

					if (lastMessage) {
						CometChat.markAsRead(lastMessage.id, this.chatBox.conversation.id, this.chatBox.conversation.type, this.chatBox.chatUser.uid);
					}

					this.$nextTick(() => {
						this.scrollToBottom();
					});
				})
				.catch((error) => console.log(error))
				.finally(() => {
					this.chatBox.loading = false;
				});
		},
		listMessageHistory() {
			let limit = this.chatBox.limit;
			let messageList;

			this.chatBox.noMore = false;
			this.chatBox.loading = true;

			this.chatBox.messageBuilder
				.fetchPrevious()
				.then((messageList) => {
					if (messageList.length < limit) {
						this.chatBox.noMore = true;
					}
					for (let m of messageList.reverse()) {
						this.chatBox.messageList.unshift(this.minimizeMessage(m));
					}
				})
				.catch((error) => console.log(error))
				.finally(() => {
					this.chatBox.loading = false;
				});
		},
		async sendMessage() {
			if (this.chatBox.chatMessage) {
				let message = new CometChat.TextMessage(
					this.chatBox.conversation.id,
					this.chatBox.chatMessage,
					this.chatBox.conversation.type == "group" ? CometChat.RECEIVER_TYPE.GROUP : CometChat.RECEIVER_TYPE.USER
				);

				message = await CometChat.sendMessage(message);
				this.chatBox.messageList.push(this.minimizeMessage(message));
				this.chatBox.chatMessage = null;

				this.conversationCreateIfNotExist(this.chatBox.conversation.type, this.chatBox.conversation.id, message.receiver.name, message);
				this.conversationLastMessage(this.chatBox.conversation.type, this.chatBox.conversation.id, message);

				this.$nextTick(() => {
					this.scrollToBottom();
				});
			}
		},
		converse(type, id, name, idx) {
			this.showMobileConversation = false;
			this.showMobileChat = true;
			this.showMobileUserOnline = false;

			if (idx || idx >= 0) {
				this.selectedConversationIndex = idx;
			}

			if (!(this.chatBox.conversation.type == type && this.chatBox.conversation.id == id)) {
				this.chatBox.conversation.type = type;
				this.chatBox.conversation.id = id;
				this.chatBox.conversation.name = name;

				this.conversationUnreadToZero(type, id);
				this.listMessageInitial();
			}
		},
		conversationCreateIfNotExist(type, id, name, message) {
			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					return;
				}
			}
			this.chatBox.conversationList.push({
				type: type,
				id: id,
				name: name,
				unreadCount: 0,
				lastMessage: message
			});
		},
		conversationUnreadToZero(type, id) {
			let anyUnreadMessages = false;

			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					conversation.unreadCount = 0;
				}

				if (conversation.unreadCount > 0) {
					anyUnreadMessages = true;
				}
			}

			if (anyUnreadMessages) {
				document.title = "You have new message(s)";
			} else {
				document.title = "V-Unite";
			}
		},
		conversationUnreadIncrement(type, id) {
			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					conversation.unreadCount++;
					document.title = "You have new message(s)";
				}
			}
		},
		conversationLastMessage(type, id, message) {
			for (let conversation of this.chatBox.conversationList) {
				if (conversation.type == type && conversation.id == id) {
					conversation.lastMessage = message;
				}
			}
		},
		content(message) {
			if (message) {
				if (message.category == "action") {
					return message.message;
				} else if (message.category == "call") {
					return message.type.charAt(0).toUpperCase() + message.type.slice(1) + " call " + message.action;
				}
			}
			return message.text;
		},
		async getGroup(guid) {
			return CometChat.getGroup(guid)
				.then((group) => {
					return group;
				})
				.catch((error) => {
					this.cometChatErrorNotif(error);
					return null;
				});
		},
		minimizeMessage(message) {
			return {
				id: message.id,
				category: message.category,
				sender: {
					uid: message.sender.uid,
					name: message.sender.name
				},
				sentAt: message.sentAt,
				// category: message
				text: message.text,
				// category: action
				message: message.message,
				// category: call
				action: message.action,
				type: message.type
			};
		},
		minimizeVisitor(visitor) {
			return { uid: visitor.uid, name: visitor.name };
		},
		minimizeConversation(conversation) {
			return {
				type: conversation.conversationType,
				id: conversation.conversationWith.uid,
				name: conversation.conversationWith.name,
				unreadCount: conversation.unreadMessageCount,
				lastMessage: conversation.lastMessage
			};
		},
		scrollToBottom() {
			let element = document.getElementById("chatBox");
			if (element) {
				element.scrollTo(0, element.scrollHeight + 30);
			}
		},
		scrollToTop() {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		scrollToChat() {
			let card = document.getElementById("chatCard");
			card.scrollIntoView({ behavior: "smooth" });
		},
		scrollToTopPage() {
			document.body.scrollTo({ top: 0, behavior: "smooth" });
			document.documentElement.scrollTo({ top: 0, behavior: "smooth" });
		},
		scrollCheck() {
			let modifier = this.isMobile ? 0.05 : 0.2;
			if (
				document.body.scrollTop > modifier * document.body.scrollHeight ||
				document.documentElement.scrollTop > modifier * document.documentElement.scrollHeight
			) {
				this.goToChat = false;
			} else {
				this.goToChat = true;
			}
		},
		soundSwitch(item) {
			item.chatNotificationSound = !item.chatNotificationSound;
			axios
				.post("/system/user/edit/sound", {
					chatNotificationSound: this.chatBox.chatNotificationSound
				})
				.then(() => {})
				.catch(() => {});
		},
		notificationSound() {
			let snd = new Audio(require("./../../assets/Chatbox/notification.ogg"));
			snd.play();
		},
		formatDate(value) {
			let date = new Date(value * 1000);
			let options = {
				year: "numeric",
				month: "long",
				day: "numeric",
				hour: "2-digit",
				minute: "2-digit",
				second: "2-digit"
			};
			return date.toLocaleString("en-US", options);
		},
		cometChatErrorNotif(error) {
			let notification = {
				title: "CometChat error",
				content: {
					errorList: [error.message],
					fieldErrorList: [],
					noticeList: [],
					type: "NOTIFICATION"
				}
			};
			this.$store.commit("showNotification", notification);
		},
		// Chat Box END

		// mobile version START
		onResize() {
			this.isMobile = window.matchMedia("only screen and (max-width: 599px)").matches;
		},
		goToSelectedTab(content) {
			this.showMobileConversation = content == 1 ? true : false;
			this.showMobileChat = content == 2 ? true : false;
			this.showMobileUserOnline = content == 3 ? true : false;

		},

		// mobile version END

		// audio-video call START

		async startCall(id, type, receiver) {
			this.call.callingProgress = true;
			let globalContext = this;

			let receiverID = id;
			let callType = type == "video" ? CometChat.CALL_TYPE.VIDEO : CometChat.CALL_TYPE.AUDIO;
			let receiverType = receiver == "user" ? CometChat.RECEIVER_TYPE.USER : CometChat.RECEIVER_TYPE.GROUP;

			let call = new CometChat.Call(receiverID, callType, receiverType);

			console.log("call object: ", call);

			CometChat.initiateCall(call).then(
				(outGoingCall) => {
					console.log("Call initiated successfully:", outGoingCall);
					globalContext.call.caller = outGoingCall.callInitiator;
					globalContext.call.receiver = outGoingCall.callReceiver;
					globalContext.call.sessionId = outGoingCall.sessionId;
				},
				(error) => {
					console.log("Call initialization failed with exception:", error);
					this.cometChatErrorNotif(error);
				}
			);
		},
		async acceptCall() {
			let globalContext = this;

			this.setOnCallAccepted().then(() => {
				globalContext.call.incomingCall = false;

				let sessionID = globalContext.call.sessionId;

				CometChat.acceptCall(sessionID).then(
					(call) => {
						console.log("Call accepted successfully:", call);

						let sessionId = call.sessionId;
						let callType = call.type;
						let callSettings = new CometChat.CallSettingsBuilder()
							.setSessionID(sessionId)
							.enableDefaultLayout(true)
							.setIsAudioOnlyCall(callType == "audio" ? true : false)
							.showScreenShareButton(false)
							.build();

						CometChat.startCall(
							callSettings,
							document.getElementById("callScreen"),
							new CometChat.OngoingCallListener({
								onUserJoined: (user) => {
									/* Notification received here if another user joins the call. */
									console.log("User joined call:", user);
								},
								onUserLeft: (user) => {
									/* Notification received here if another user left the call. */
									console.log("User left call:", user);
								},
								onCallEnded: (call) => {
									/* Notification received here if current ongoing call is ended. */
									console.log("Call ended:", call);
									globalContext.call.ongoingCall = false;
									globalContext.call.incomingCall = false;
									globalContext.call.callingProgress = false;
									globalContext.call.receiverId = null;
									globalContext.call.sessionId = "";
								},
								onError: (error) => {
									console.log("Call error :", error);
									globalContext.call.ongoingCall = false;
									globalContext.call.incomingCall = false;
									globalContext.call.callingProgress = false;
									globalContext.call.receiverId = null;
									globalContext.call.sessionId = "";
								}
							})
						);
					},
					(error) => {
						console.log("Call acceptance failed with error", error);
						this.cometChatErrorNotif(error);
					}
				);
			});
		},
		async rejectCall(type) {
			let sessionID = this.call.sessionId;
			let globalContext = this;
			let status = type == "reject" ? CometChat.CALL_STATUS.REJECTED : CometChat.CALL_STATUS.CANCELLED;

			await CometChat.rejectCall(sessionID, status).then(
				(call) => {
					console.log("Call rejected successfully", call);
					globalContext.call.incomingCall = false;
					globalContext.call.ongoingCall = false;
					globalContext.call.callingProgress = false;
					globalContext.call.receiverId = null;
					globalContext.call.sessionId = "";
				},
				(error) => {
					console.log("Call rejection failed with error:", error);
					globalContext.call.incomingCall = false;
					globalContext.call.ongoingCall = false;
					globalContext.call.callingProgress = false;
					globalContext.call.receiverId = null;
					globalContext.call.sessionId = "";

					this.cometChatErrorNotif(error);
				}
			);
		},
		async callUser(id, type, receiver) {
			this.call.receiverId = id;
			await this.startCall(this.call.receiverId, type, receiver);
		},
		async setOnCallAccepted() {
			let globalContext = this;
			return new Promise(function (resolve, reject) {
				globalContext.call.ongoingCall = true;
				resolve();
				console.log(reject);
			});
		},
		// audio-video call END

		findExperienceColors() {
			axios
				.post("/system/experienceColors/find", {
					tenantSlug: this.tenantSlug,
					experienceSlug: this.experienceSlug,
					page: "Presentation"
				})
				.then((response) => {
					if (response.data) {
						this.presentationColor = response.data;
						console.log(this.presentationColor)
					}
				})
				.catch(() => {});
		},
		modifyVideoUrl(videoUrl) {
			if (videoUrl.includes("player.vimeo.com") && videoUrl.includes("?")) {
				return videoUrl + "&autoplay=1&showinfo=0&controls=1";
			} else {
				return videoUrl + "?autoplay=1&showinfo=0&controls=1";
			}
		},
		getUsernameForChatRoom(principal) {
			let username = principal.firstName + " " + principal.lastName;
			username += principal.title ? (" - " + principal.title) : "";
			return username;
		}
	}
};
</script>
